<template>
  <div class="stepper-wrapper">
    <div class="stepper-item" :class="{'completed': step.completed}" v-for="step in data" :key="step.id">
      <div class="step-counter"></div>
      <div class="step-name">{{ step.name }}</div> 
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
  id: String,
  color: String,
  size: String,
  selected: { type: Object, default: {} }
});

const activePipelines = computed(() => store.getters['pipelines/getActivePipelines']);

const data = computed(() => {
  let states = [];
  activePipelines?.value?.map(el => {
    states.push({
      id: el.id,
      name: el.name,
      completed: el.order <= props.selected?.order,
    });
  });

  return states;
});
</script>

<style scoped>
.stepper-wrapper {
  margin: auto;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 5px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 5px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: var(--bs-primary);
}

.stepper-item.completed .step-name {
  color: var(--bs-primary);
}

.stepper-item.completed::before {
  border-bottom: 2px solid var(--bs-primary);
}

.stepper-item:first-child::before {
  left: 0%;
}

.stepper-item:last-child::after {
  content: none;
}

@media (max-width: 768px) {
  .stepper-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .stepper-item {
    margin-bottom: 15px;
    width: 100%;
    text-align: center;
  }

  .stepper-item::before, .stepper-item::after {
    display: none;
  }
}
</style>
